import { hooks } from '@adc/ui-core'
import { useInfiniteScroll } from './infiniteScroll'
import useWindowDimensionsHook from './useWindowDimensionsHook'
import useFreshnessDetection from './useFreshnessDetection'
const { useStripePayment } = hooks
export {
  useFreshnessDetection,
  useWindowDimensionsHook,
  useInfiniteScroll,
  useStripePayment,
}
